import { render, staticRenderFns } from "./ExerciseDetailsTabContent.vue?vue&type=template&id=740829be&"
import script from "./ExerciseDetailsTabContent.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetailsTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports